export default __webpack_public_path__ + "static/takamol-logo.bcf66999.svg";